import React from 'react';
import { array } from 'prop-types';
import _ from 'lodash';

import HeaderRowContainer from '../common/HeaderRowContainer';
import Row from '../common/Row';
import ReportsListRow from './ReportsListRow';

const ReportsList = ({ reports }) => (
  <div>
    <HeaderRowContainer>
      <Row>NOMBRE</Row>
      <Row>FECHA</Row>
      <Row>TIPO</Row>
      <Row>ESTADO</Row>
    </HeaderRowContainer>
    {_.isEmpty(reports) ?
      <div className="empty-state">No se encontraron reportes</div> :
      reports.map((report, index) =>
        <ReportsListRow {...report} key={`${report.name} ${index}`} />
      )
    }
  </div>
);

ReportsList.propTypes = {
  reports: array.isRequired
};

export default ReportsList;



// WEBPACK FOOTER //
// ./src/components/report/ReportsList.js